module.exports = {"id":"189397","name":"Florian Jungwirth","rating":"72","photo":"./data/images/photos/4/189397.png","club":{"name":"SJ Earthquakes","logo":"./data/images/clubs/SJEarthquakes.png"},"positions":["MDC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FlorianJungwirth0.json
// module id = 1450
// module chunks = 0